// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__31zuN","col":"styles_col__IWn0I","fulfillmentStatus":"styles_fulfillmentStatus__SkRo7","emailCol":"styles_emailCol__1mmIK"};